import React from 'react'

export const COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_5 = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'espacioTotalEnTns',
    label: 'Espacio Total [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '30%' }}>
            {(value !== null) ? `${parseFloat(value).toFixed(2)}` : 0}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioTotalEnCamiones',
    label: 'Espacio Total [Camiones]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '30%' }}>
            {(value !== null) ? `${parseFloat(value).toFixed(0)}` : 0}
          </div>
        )
      }
    }
  }
]

export const COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_5_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'espacioTotalEnTns',
    label: 'Espacio Total [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'espacioTotalEnCamiones',
    label: 'Espacio Total [Camiones]',
    width: 60,
    mantenerCase: true
  }
]
